import "./drawer.css";
import DrawerHeader from "./DrawerHeader";
import DrawerSingleFooter from "./DrawerSingleFooter";

interface AppDrawerSingleFooterProps {
  title: string;
  subtitle: string;
  submit?: string;
  openDrawer: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const AppDrawerSingleFooter = ({
  title,
  subtitle,
  openDrawer,
  submit,
  onClose,
  children,
  onSubmit,
  loading,
  disabled,
}: AppDrawerSingleFooterProps) => {
  return (
    <div className={`backdrop ${openDrawer ? "visible" : "hidden"}`}>
      <div className={`gx-app-drawer ${openDrawer ? "open" : ""}`}>
        {/* Drawer Header */}
        <DrawerHeader
          title={title}
          subtitle={subtitle}
          handleClose={onClose ?? (() => {})}
        />

        {/* Drawer Body */}
        <div className="drawer-content  ">{children}</div>

        {/* Drawer Footer */}
        <DrawerSingleFooter
          handleClose={onClose ?? (() => {})}
          handledrawerSubmit={onSubmit ?? (() => {})}
          submit={submit}
          loading={loading}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
